import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import {
  GIFT_NO_RESULTS,
  CLEAR_YOUR_FILTERS,
  TRY_AGAIN,
} from '../../../config/text/text';

export const GiftFinderFiltersEmpty = ({ setFilterReset }) => {
  const resetFilters = (event) => {
    event.preventDefault();
    setFilterReset(true);
  };

  return (
    <>
      <div className="message">
        <div className="message-text">
          {GIFT_NO_RESULTS}
          <Link href="/">
            <a className="clear-filter" href="/" onClick={resetFilters}>
              {CLEAR_YOUR_FILTERS}
            </a>
          </Link>
          {TRY_AGAIN}
        </div>
      </div>
      <style jsx>
        {`
          .message {
            padding-right: 10%;
            padding-left: 10%;
            text-align: center;
          }
          .message-text {
            margin-bottom: 25px;
            font-size: 16px;
            font-weight: bold;
            color: #000;
            padding: 40px 20px;
          }
          .clear-filter {
            color: black;
            text-decoration: underline;
            font-weight: bold;
            cursor: pointer;
          }
        `}
      </style>
    </>
  );
};

GiftFinderFiltersEmpty.propTypes = {
  setFilterReset: PropTypes.func,
};
